<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">{{i18nPurchasedPackages.purchased_packages}}</div>
    </div>
    <div class="device-select" @click="showPicker=true" v-if="deviceSn !== 'null' ">
      <label>{{deviceSn}}</label>
      <van-image :src="require('assets/imgs/bottom.png')" width="18px" height="18px" style="vertical-align: -5px;display: inline-block"></van-image>
    </div>
    <div style="position: fixed;bottom: 0;left: 0;right: 0;background: #f1ebeb;z-index: 9999" v-if="showPicker">
      <van-picker
        show-toolbar
        :columns="columns"
        :cancel-button-text="i18n.msg_fail_cancel"
        :confirm-button-text="i18n.msg_fail_confirm"
        @cancel="showPicker=false"
        @confirm="snConfim"
      />
    </div>
    <PurchasedItem v-for="(item, i) in orderList2" :key="i" :src="item.flagUrl" :country="item.country"
                   :currencyName="item.currencyName" :reserverEndTime="item.reserverEndTime" :orderId="item.orderId"
                   :reserverStartTime="item.reserverStartTime" :totalAmount="item.totalAmount" :currency="item.currency"
                   :packageUsageTotal="item.packageUsageTotal" :packageStatusTitle="item.packageStatusTitle"
                   :tradeNo="item.orderId" :deviceOrderStatus="item.deviceOrderStatus" :packagePrice="item.packagePrice"
                   :text="item.text" :packageStatus="item.packageStatus"
    ></PurchasedItem>
    <div v-if="orderList2.length == 0" style="margin-top: 200px;">
      <van-image :src="require('assets/imgs/device_empt.png')"></van-image>
    </div>
    <div class="activity-foot">
      <div class="go-home" @click="backHome">
        <img src="../../assets/imgs/go_back_home.png" @click="onBack">
        <label class="content">{{i18nDeviceManager.back_to_home}}</label>
      </div>
    </div>
    <div style="position: fixed;right: 20px;bottom: 15%;">
      <a href="whatsapp://send?phone=+528129035171">
        <img src="../../assets/imgs/contactus/icon_whatsapp.png" alt="" height="40px" width="40px">
      </a>
    </div>
<!--    <van-tabs :active="active" color="#1EBE86" title-active-color="#1EBE86" background="#F4F4F4">-->
<!--      <van-tab title="All">-->
<!--        <PurchasedItem v-for="(item, i) in orderList1" :key="i"></PurchasedItem>-->
<!--      </van-tab>-->
<!--      <van-tab title="Purchased">-->
<!--        <PurchasedItem v-for="(item, i) in orderList2" :key="i" :src="item.flagUrl" :country="item.country"-->
<!--                       :currencyName="item.currencyName" :reserverEndTime="item.reserverEndTime"-->
<!--                       :reserverStartTime="item.reserverStartTime" :totalAmount="item.totalAmount"-->
<!--                       :packageUsageTotal="item.packageUsageTotal"-->
<!--        ></PurchasedItem>-->
<!--      </van-tab>-->
<!--      <van-tab title="Completed">-->
<!--        <PurchasedItem v-for="(item, i) in orderList3" :key="i"></PurchasedItem>-->
<!--      </van-tab>-->
<!--    </van-tabs>-->
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { USER_CAPTCHA, LOGIN_CODE, SEND_CODE, SEND_CODE2, USER_INFO } from '../../apis/user'
import { LoginApple, LoginGoogle } from '../../components/login'
import PurchasedItem from '../../components/purchasedItem/purchasedItem.vue'
import { mapState } from 'vuex'
import AreaCodeDate from '@/utils/area_code.js'
import CollapseItem from 'components/help/collapse_item.vue'
import { MIFI_DEVICE } from '@/apis/cabinet'
export default {
  components: {
    PurchasedItem
  },
  computed: {
    ...mapState(['mifiDevices', 'mifisn']),

    i18n () {
      return this.$t('confirm')
    },
    i18nPurchasedPackages() {
      return this.$t('purchasedPackages')
    },
    i18nDeviceManager () {
      return this.$t('deviceManager')
    }
  },
  watch: {

  },
  data () {
    return {
      active: 1,
      value1: 0,
      columns: null,
      deviceSn: '',
      showPicker: false,
      typeMap: {},
      orderList1: [],
      orderList2: [],
      orderList3: []
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    },
    snConfim(value, index) {
      this.showPicker = false
      this.deviceSn = value
      this.getOrderList()
    },
    getOrderList() {
      this.$loading(true)
      this.$post('/chargenow/mifi/orderList', {
          current: 1,
          size: 20,
          sn: this.deviceSn,
          type: 1
        }, res => {
          this.$loading(false)
          let data = res.data.records
          data = data ? data.map(item => {
            item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
            if (item.packageName.split('-')[2].includes('Days')) {
              item.text = `${item.country}${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.days}`
              item.isPackage = 1
            } else if (item.packageName.split('-')[2].includes('Unlimited')) {
              item.text = `${item.country}${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
              item.isPackage = 0
            } else {
              item.text = `${item.country}${item.packageName.split('-')[2]}MB/${this.i18n.天}`
              item.isPackage = 0
            }
            item.packageStatusTitle = this.typeMap[item.packageStatus]
            console.log(item.packageStatusTitle)
            return item
          }) : []
          // this.orderList.push(...data)
          this.orderList2 = data
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    deviceList() {
      this.$post(
        MIFI_DEVICE, {}, (resp) => {
          this.deviceItems = resp.list
          var mifiDevices = []
          if (this.deviceItems.length > 0) {
            this.deviceInfo = this.deviceItems[0]
            this.deviceSn = this.deviceInfo.pSn
            this.$store.commit('mifisn', this.deviceItems[0].pSn)
            for (let i = 0; i < this.deviceItems.length; i++) {
              mifiDevices.push(this.deviceItems[i].pSn)
              if (this.deviceItems[i].pdefault === 1) {
                this.deviceSn = this.deviceItems[i].pSn
                this.deviceInfo = this.deviceItems[i]
              }
            }
          }
          console.log(mifiDevices)
          this.$store.commit('mifiDevices', mifiDevices)
          this.columns = this.mifiDevices
          console.log(this.columns)
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    if (this.$route.query.deviceSn) {
      this.deviceSn = this.$route.query.deviceSn
    } else {
      this.deviceSn = this.mifisn
    }
    this.getOrderList()
    this.deviceList()
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      9: this.i18n.type_9,
      33: this.i18n.type_33,
      88: this.i18n.type_88
    }
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
  .device-select{
    text-align: left;
    border-left: 5px solid #1EBE86;
    margin-left: 20px;
    margin: 20px;
    label{
      font-weight: bold;
      font-size: 32px;
      color: #333333;
      margin-left: 15px;
    }
  }
}
.activity-foot {
  width: 100%;
  margin: 40px auto 0;
  bottom: 0;
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  background: #eeebeb;
  .activation-btn{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    border: none;
    width: 670px;
    height: 98px;
    background: #1EBE86;
    border-radius: 50px 50px 50px 50px;
    margin-top: 49px;
  }
  .go-home{
    text-align: center;
    width: 100%;
    margin: 21px auto;
    img{
      width: 34px;
      height: 34px;
      vertical-align: -5px;
      display: inline-block;
    }
    .content{
      font-family: Montserrat, Montserrat;
      font-weight: 400;
      font-size: 28px;
      color: #1EBE86;
      margin-top: -3px;
    }
  }
}
</style>
